var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.55 3.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    strokeWidth: "0px",
    d: "M50.82.09v3.6h2.73v-.66h-1.94v-.88h1.74v-.61h-1.74v-.77h1.9V.09h-2.69ZM47.83.09v3.6h2.54v-.66h-1.75V.09h-.79ZM44.85.09v3.6h2.54v-.66h-1.75V.09h-.79ZM43.36.09v3.6h.79V.09h-.79ZM41.3.97l.45,1.32h-.93l.47-1.32h.01ZM40.89.09l-1.36,3.6h.8l.28-.8h1.34l.27.8h.82l-1.34-3.6h-.81ZM36.55.09v.66h1.08v2.93h.79V.75h1.08V.09h-2.95ZM34.57,0l-1.4,3.77h.57l1.4-3.77h-.57ZM28.91.09v3.6h2.73v-.66h-1.94v-.88h1.74v-.61h-1.74v-.77h1.9V.09h-2.69ZM25.56.09v.66h1.78l-1.93,2.31v.62h3.03v-.66h-1.98l1.93-2.31V.09h-2.83ZM24.16.09v3.6h.79V.09h-.79ZM22.13,0c-.66,0-1.34.36-1.34,1.08,0,.46.24.76.79.94.23.08.46.13.73.2.44.11.63.26.63.48,0,.33-.34.45-.7.45s-.79-.16-.79-.66h-.77v.03c0,.89.78,1.25,1.53,1.25.96,0,1.5-.47,1.5-1.15,0-.49-.3-.78-.67-.93-.16-.07-.35-.11-.51-.15-.81-.21-.96-.25-.96-.51,0-.28.26-.41.55-.41.47,0,.68.18.7.54h.77c0-.82-.67-1.16-1.44-1.16ZM18.63,0l-1.4,3.77h.57l1.4-3.77h-.57ZM14.16.97l.45,1.32h-.93l.47-1.32h.01ZM13.76.09l-1.36,3.6h.8l.28-.8h1.34l.27.8h.82L14.57.09h-.81ZM9.79.09v3.6h2.54v-.66h-1.75V.09h-.79ZM6.81.09v3.6h2.54v-.66h-1.75V.09h-.79ZM4.74.97l.45,1.32h-.93l.47-1.32h.01ZM4.34.09l-1.36,3.6h.8l.28-.8h1.34l.27.8h.82L5.15.09h-.81ZM0,.09v.66h1.08v2.93h.79V.75h1.08V.09H0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalla);
export default __webpack_public_path__ + "static/media/talla.0bfe0115f5054ba26b7ab69441ab1662.svg";
export { ForwardRef as ReactComponent };